module.exports = __webpack_public_path__ + "img/大場直洋.b685c64d.jpg";